import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=421f3066&scoped=true&"
var script = {}
import style0 from "./Exchange.vue?vue&type=style&index=0&id=421f3066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f3066",
  null
  
)

export default component.exports